import React, { useContext } from "react";
import "./NavTabsBar.css"; // 👈 we’ll define hover styles here
import permissionContext from "../../../_helper/permissions";

const NavTabsBar = ({ tabs, activeTab, onTabChange }) => {
  const {hasPermission}=useContext(permissionContext)
  const allowedTabs = tabs.filter(tab =>
  hasPermission(tab.permission)
);  
  return (
    <ul className="nav nav-tabs bg-white rounded mb-4 d-flex w-100 text-center border-0 bg-smoke p-2 rounded-4">
      {allowedTabs.map((tab) => (
        <li className="nav-item flex-fill" key={tab.key}>
          <button
            type="button"
            className={`nav-link w-100 fs-5 fw-medium border-0 rounded-4 ${
              activeTab === tab.key
                ? "active text-white "
                : "text-dark"
            } hover-primary`}  
            onClick={() => onTabChange(tab.key)}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default NavTabsBar;   
